
import Header from "../../../Components/Header/Header";
import { LeftSettings } from '../LeftSettings';
import { ORGANIZATIONSTATIONSTATIONLIST, SLOTPLANNINGWAREHOUSEADDEDIT, SLOTPLANNINGWAREHOUSEDELETERESTORE } from '../../../Utils/conts.js';
import { useEffect, useRef, useState } from "react";
import { withRFSToken } from '../../../Services/axios';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Trash from "../../../assets/images/trash.png";
import Edit from "../../../assets/images/edit.png";
import { Button, Form, Modal } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';
const WarehouseSettings = () => {
  const isMounted = useRef(false);
  const [stationData, setStationData] = useState([]);
  const [activeStation, setActiveStation] = useState(null);
  const [addEditWareHousemodal, setAddEditWareHousemodal] = useState(false);
  const gridRefs = useRef(null);
  const [allData, setAlldata] = useState(null);
  const [editDeleteData, setEditDeleteData] = useState({});
  const [confModal, setConfModal] = useState(false);

  useEffect(() => {
    if (isMounted.current) return;
    loadStation();
    isMounted.current = true;
  }, []);

  const loadStation = async () => {
    try {
      const res = await withRFSToken.get(ORGANIZATIONSTATIONSTATIONLIST);
      const innerData = res.data.response_data;
      setStationData(innerData);
      if (innerData.length > 0) {
        setActiveStation(innerData[0]);
      }
    } catch (error) {
      console.error('Error sending request:', error);
    }
  }

  const handleWarehouseClick = (org_station_id) => {

    const selectedStation = stationData.find(station => station.org_station_id === Number(org_station_id));
    console.log('selectedStation', selectedStation);
    setActiveStation(selectedStation);
  };

  useEffect(() => {
    if (activeStation !== null && activeStation !== undefined && activeStation !== '') {

      loadGrid();
    }
  }, [activeStation]);

  const loadGrid = () => {
    if (!activeStation || !activeStation.org_station_id) return;
    const token = 'Bearer ' + localStorage.airlinetoken;
    const source = {
      datatype: 'json',
      url: `${process.env.REACT_APP_RFS_URL}warehouse/list?org_station_id=${activeStation.org_station_id}`,
      root: 'response_data',
      cache: false,
      datafields: [
        { name: 'doors_count', type: 'string' },
        { name: 'id', type: 'number' },
        { name: 'name', type: 'string' },
        { name: 'status', type: 'string' },
        { name: 'name_contains', type: 'string' },
        { name: 'warehouse_type', type: 'string' },
        { name: 'address_contains', type: 'string' },
      ],
      beforeSend: (jqXHR) => {
        jqXHR.setRequestHeader('Authorization', token);
      },
      filter: function (allfilters) {
        window.$(gridRefs.current).jqxGrid('clearselection');
        window.$(gridRefs.current).jqxGrid("updatebounddata", "filter");
      },
      beforeprocessing: function (data) {
        setAlldata(data.response_data);
      }
    };
    const dataAdapter = new window.$.jqx.dataAdapter(source);
    const columns = [
      {
        text: 'Action', datafield: '', width: '8%', filtertype: '',
        cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
          return `<div class="grid_actions"><img class="door_edit" src="${Edit}"/><img class="door_delete" src="${Trash}"/></div>`;
        }
      },
      { text: 'Doors Count', datafield: 'doors_count', width: '15%' },
      { text: 'Name', datafield: 'name', width: '15%' },
      { text: 'Warehouse Phone', datafield: 'name_contains', width: '15%' },
      { text: 'Warehouse Type', datafield: 'warehouse_type', width: '15%' },
    ];
    const gridOptions = {
      width: '100%',
      source: dataAdapter,
      columns: columns,
      autoheight: false,
      height: 800,
      sortable: true,
      altrows: false,
      enabletooltips: true,
      editable: false,
      pageable: true,
      pageSize: 50,
      pagerButtonsCount: 5,
      pagerMode: 'advanced',
      filterable: true,
      filterrowheight: 45,
      showfilterrow: true,
      rowsheight: 42,
      columnsheight: 45,
      virtualmode: true,
      rendergridrows: function (params) {
        return params.data;
      },
    };

    window.$(gridRefs.current).jqxGrid(gridOptions);
    window.$(gridRefs.current).off('click', '.door_edit').on('click', '.door_edit', function () {
      const rowDiv = window.$(this).closest('[role="row"]');
      const rowIndex = window.$(rowDiv).attr('row-id');
      const rowData = window.$(gridRefs.current).jqxGrid('getrowdata', rowIndex);
      setEditDeleteData({
        warehouse_name: rowData.name,
        warehouse_type: rowData.warehouse_type,
        name_contains: rowData.name_contains,
        warehouse_id: rowData.id,
        address_contains: rowData.address_contains,
      });
      setAddEditWareHousemodal(true);
    });
    window.$(gridRefs.current).off('click', '.door_delete').on('click', '.door_delete', function () {
      const rowDiv = window.$(this).closest('[role="row"]');
      const rowIndex = window.$(rowDiv).attr('row-id');
      const rowData = window.$(gridRefs.current).jqxGrid('getrowdata', rowIndex);
      setEditDeleteData(rowData);
      setConfModal(true);
    });
  };

  const addWareHouseClose = () => { setAddEditWareHousemodal(false); }

  const handleChange = (e) => {
    let { name, value } = e.target;
    setEditDeleteData({ ...editDeleteData, [name]: value });
  }

  const handleAddwareHouse = (e) => {
    setEditDeleteData([]);
    setAddEditWareHousemodal(true);
  }

  const addWarehouse = async () => {
    const payload = { ...editDeleteData, org_station_id: activeStation.org_station_id, station_id: activeStation.station_id }
    try {
      const res = await withRFSToken.post(SLOTPLANNINGWAREHOUSEADDEDIT, payload)
        .then(function (res) {
          if (res.data.response_code == 200) {
            toast.success(res.data.response_msg);
          } else {
            toast.error(res.data.response_msg);
          }
          setAddEditWareHousemodal(false)
          loadGrid()
        });

    } catch (error) {
      console.error('Error sending request:', error);
    }
  }

  const handleConfirmation = (confirm) => {
    if (confirm) {
      handleDoorDelete(editDeleteData.id)
      setConfModal(false);
    } else {
      closeConfirm();
    }
  }

  const closeConfirm = () => {
    setConfModal(false);
  }

  const handleDoorDelete = async (commentId) => {
    const res = await withRFSToken.post(SLOTPLANNINGWAREHOUSEDELETERESTORE, { 'warehouse_id': editDeleteData.id })
    if (res.data.response_code == 200) {
      if (res.data.response_code == 200) {
        toast.success(res.data.response_msg);
        closeConfirm();
        loadGrid();

      } else {
        toast.error(res.data.response_msg);
      }
    } else {
      toast.error(res.data.response_msg);
    }
  }
  return (
    <>
      {console.log('activeStation-1', activeStation)}
      {/* <div className="">
        <Header logo_url='/HandlerAdmin' sBackUrl='/HandlerAdmin' mode='SAS' />
        <div className="main-panel">
          <div className="row">
            <LeftSettings mode='HSA' /> */}
      <div className='col-9 col-xxl-9 stting_right'>
        <div className='settingbg_right'>
          <h4>Warehouse Setting</h4>
          <p>Set your notification preferences for when you are in or away from the dashboard.</p>
          <div className='d-flex justify-content-between'>
            <div>
              <Button variant="primary createplan" onClick={handleAddwareHouse}>
                <FontAwesomeIcon icon={faPlus} /> Add Warehouse
              </Button>
            </div>
            <div className='rastatus'>
              {/* <span>Status : </span>
                      <Form.Select>
                        <option>All</option>
                        <option value="1">One</option>
                        <option value="2">Two</option>
                        <option value="3">Three</option>
                      </Form.Select> */}
            </div>
          </div>
          <Tabs id="station-tabs" activeKey={activeStation?.org_station_id} onSelect={handleWarehouseClick} className="booking_tab">
            {stationData?.map((station) => (
              <Tab
                eventKey={station.org_station_id}
                key={station.org_station_id}
                title={
                  <>
                    <span>
                      {station.station_name}
                      <span className="rabadge badge bg-primary ms-2 ssss">{station.total_warehouse}</span>
                    </span>
                  </>
                }
              />
            ))}
          </Tabs>
          <div ref={gridRefs} id="warehouseGrid" />
        </div>
      </div>
      {/* </div>
        </div>
      </div> */}
      <Modal show={addEditWareHousemodal} onHide={addWareHouseClose} centered className='addfrom wire_house'>
        <Modal.Header closeButton onClick={addWareHouseClose}>
        </Modal.Header>
        <Modal.Body>
          <>
            <h3> Add Warehouse </h3>
            <Form.Group className='mb-2'>
              <Form.Label>Warehouse Name <span className="text-danger"> *</span></Form.Label>
              <Form.Control
                type="text"
                onChange={handleChange}
                name='warehouse_name'
                placeholder="Warehouse Name"
                value={editDeleteData.warehouse_name}
              />
            </Form.Group>
            <Form.Group className='mb-2'>
              <Form.Label>Handler Name Contains <span className="text-danger"> *</span></Form.Label>
              <Form.Control
                type="text"
                onChange={handleChange}
                name='name_contains'
                placeholder="Handler Name Contains"
                value={editDeleteData.name_contains}
              />
            </Form.Group>
            <Form.Group className='mb-2'>
              <Form.Label>Handler Address Contains <span className="text-danger"> *</span></Form.Label>
              <Form.Control
                type="text"
                onChange={handleChange}
                name='address_contains'
                placeholder="Handler Address Contains"
                value={editDeleteData.address_contains}
              />
            </Form.Group>
            <Form.Group className='mb-2'>
              <Form.Label>Warehouse Type</Form.Label>
              <Form.Control
                type="text"
                onChange={handleChange}
                name='warehouse_type'
                placeholder="Warehouse Type"
                value={editDeleteData.warehouse_type}
              />
            </Form.Group>
          </>
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex w-75 mx-auto are_bottom">
            <Button variant="secondary" onClick={addWareHouseClose}>
              Cancel
            </Button>
            <Button variant="primary" onClick={addWarehouse}>
              Save Warehouse
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
      <Modal show={confModal} onHide={closeConfirm} className="addfrom change_type" centered>
        <Modal.Header closeButton onClick={closeConfirm}></Modal.Header>
        <Modal.Body>
          <h3>The Warehouse will be deleted. </h3>
          <p>Are you sure you want to continue?</p>
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex w-50 mx-auto are_bottom">
            <Button variant="secondary" onClick={() => handleConfirmation(false)}> No</Button>
            <Button variant="primary" onClick={() => handleConfirmation(true)}> Yes </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default WarehouseSettings;